import { useSettingsStore } from '@/stores/settingsStore'

/** Locale used by every formatter, so number rendering is switchable in one place. */
export function useLocale(): string {
  return useSettingsStore((state) => state.locale)
}
